import AppHeader from '../AppHeader'
import DayJs from 'dayjs'
export default {
  name: 'stock-analysis',
  created () {
    this.getShop(),
    this.getAvailableDate()
  },
  components: {
    AppHeader
  },
  data () {
    return {
      shopId: '',
      startYearMonth: '',
      startWeeklyNumber: '',
      endYearMonth: '',
      endWeeklyNumber: '',
      shops: [],
      availableDates: '',
      shopGetEnd: false,
      dateGetEnd: false,
      error: false
    }
  },
  computed: {
    selectYearMonths () {
      let hash = []
      for (let key in this.availableDates) {
        hash.push(key)
      }
      return hash
    },
    selectStartWeekNumbers () {
      return this.availableDates[this.startYearMonth]
    },
    selectEndWeekNumbers () {
      return this.availableDates[this.endYearMonth]
    }
  },
  methods: {
    async getShop () {
      let data = {}
      let res = await this.$store.dispatch('GET_SHOP_TARGET_STOCK', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.shops = res.data
      this.shopGetEnd = true
    },
    async getAvailableDate () {
      let data = {}
      let res = await this.$store.dispatch('GET_STOCK_AVAILABLE_DATE', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.availableDates = res.dates.data
      this.startYearMonth = res.first_month
      this.endYearMonth = res.last_month
      this.dateGetEnd = true
    },
    formatYearMonth (yearMonth) {
      return yearMonth.substr(0, 4) + '年' + yearMonth.substr(4, 2) + '月'
    },
    async output () {
      if (!this.startWeeklyNumber || !this.endWeeklyNumber) {
        this.error = true
        return false
      } else if (this.startYearMonth > this.endYearMonth || (this.startYearMonth == this.endYearMonth && this.startWeeklyNumber > this.endWeeklyNumber)) {
        this.error = true
        return false
      } else {
        this.error = false
      }
      let data = {
        shop_id: this.shopId,
        start_year_month: this.startYearMonth,
        start_weekly_number: this.startWeeklyNumber,
        end_year_month: this.endYearMonth,
        end_weekly_number: this.endWeeklyNumber
      }
      let res = await this.$store.dispatch('STOCK_ANALYSIS_CSV', data)
                .catch(err => {
                  console.log(err)
                  return
                })
      this.csvDownload(res.csv_data)
    },
    csvDownload (data) {
      const csvFileName = '在庫分析.csv'
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let mimeType = 'text/csv'
      let csv = '店舗名,消耗品名,型番,1ロットあたり数量,発注数(ロット単位),在庫数(数),発注日,備考\n'
      data.forEach(obj => {
        if (obj.shop_name) {
          csv += this.enquoteForCSV(obj.shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.consumable_item_name) {
          csv += this.enquoteForCSV(obj.consumable_item_name) + ','
        } else {
          csv += ','
        }
        if (obj.product_code) {
          csv += this.enquoteForCSV(obj.product_code) + ','
        } else {
          csv += ','
        }
        if (obj.lot_number) {
          csv += this.enquoteForCSV(obj.lot_number) + ','
        } else {
          csv += '0,'
        }
        if (obj.order_lot_quantity) {
          csv += this.enquoteForCSV(obj.order_lot_quantity) + ','
        } else {
          csv += '0,'
        }
        if (obj.stock_quantity) {
          csv += this.enquoteForCSV(obj.stock_quantity) + ','
        } else {
          csv += '0,'
        }
        if (obj.deadline_date) {
          csv += this.enquoteForCSV(DayJs(obj.deadline_date).format('YYYY年MM月DD日')) + ','
        } else {
          csv += ','
        }
        if (obj.comment) {
          csv += this.enquoteForCSV(obj.comment)
        }
        csv += '\n'
      })
      const blob = new Blob([bom, csv], { type: mimeType })
      let hiddenElement = document.createElement('a')
      hiddenElement.download = csvFileName
      hiddenElement.target = '_blank'
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName)
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob)
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
        document.body.removeChild(hiddenElement)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
        hiddenElement.click()
      }
    },
    enquoteForCSV: function (val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"'
      }
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stock-analysis.js